export default __webpack_public_path__ + "static/media/icn-wtd-engine-brake.7dd6ba94.svg";